module.exports = __webpack_public_path__ + "img/list13.84d45235.png";